import { notification } from 'antd';
import firebase from 'firebase/app';
import 'firebase/storage';
import * as mixpanel from 'mixpanel-browser'; // Todo: fix it with improt, it didn't work when I was doing it
import moment from 'moment';
import React from 'react';
import ReactGA from 'react-ga';
import * as Constant from '../components/shared/constant';
import { generateCustomToken } from '../store/actions/authActions';

export const MONTHLY_PLANS = [
  {
    name: 'Product Teams',
    id: 27329,
    price: 5.99,
  },
  {
    name: 'Digital Agencies',
    id: 27330,
    price: 7.99,
  },
];

export const YEARLY_PLANS = [
  {
    name: 'Product Teams',
    id: 27331,
    price: 57.48,
  },
  {
    name: 'Digital Agencies',
    id: 27332,
    price: 76.88,
  },
];

export const sendImageToStore = (dataUrl: string) => {
  const fileName = 'file' + new Date().getTime();
  const storageRef = firebase
    .storage()
    .ref()
    .child(fileName);
  return storageRef.putString(dataUrl, 'data_url').then((imageData: any) => {
    return imageData.ref.getDownloadURL().then((url: string) => {
      return url;
    });
  });
};

export const sendVideoToStore = (blob: any) => {
  const fileName = 'file' + new Date().getTime();
  const storageRef = firebase
    .storage()
    .ref()
    .child(fileName);
  return storageRef.put(blob);
  // .then((videoData: any) => {
  //   return videoData.ref.getDownloadURL().then((url: string) => {
  //     return url;
  //   });
  // });
};

export const isDataURL = (s: string) => {
  const isDataUrlString = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
  return !!s.match(isDataUrlString);
};

export function sendMessageToIframe(iframe: any, event: string, data: any) {
  if (iframe && iframe.contentWindow) {
    const el = iframe.contentWindow;
    el.postMessage({ event, data }, '*');
  }
}

export function checkImageURL(url: string) {
  return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
}

export function getQueryStringValue(key: string) {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        '^(?:.*[&\\?]' +
          encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') +
          '(?:\\=([^&]*))?)?.*$',
        'i',
      ),
      '$1',
    ),
  );
}

// export function TrackGAEvent(category: string, action: string, value?: any) {
//   ReactGA.initialize('UA-165889403-1');
//   ReactGA.event({
//     category,
//     action,
//     value,
//   });
// }
const getUserLocation = async () => {
  return await fetch('https://ipapi.co/json')
    .then((res) => res.json())
    .then((data) => data);
};
let locationData = '';
const trackAnalytics = async (category: string, action: string, value: any = '') => {
  if (true || process.env.NODE_ENV === 'production') {
    let userDetails: any = await window.localStorage.getItem('userId');
    userDetails = JSON.parse(userDetails);
    const userId = userDetails && userDetails.uid ? userDetails.uid : 'anonymous';
    if (!(userDetails && userDetails.email.includes('@reactgeeks.com'))) {
      if (!locationData) {
        locationData = await getUserLocation();
      }
      const firestore = firebase.firestore();

      // We track analytics in four different sources for later cohort analysis

      // 1. Firebase Analytics
      const analytics = firebase.analytics();
      analytics.logEvent(category + ' => ' + action, { params: value });

      // 2. manually dumping it in a firebase collection
      firestore.collection('events').add({
        category,
        action,
        value,
        userId,
        moreInfo: {
          geolocation: locationData,
          date: new Date(),
          navigator: {
            appCodeName: navigator.appCodeName,
            appName: navigator.appName,
            appVersion: navigator.appVersion,
            cookieEnabled: navigator.cookieEnabled,
            language: navigator.language,
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            onLine: navigator.onLine,
          },
        },
      });

      // 3. Google Analytics
      ReactGA.initialize('UA-165889403-2');
      ReactGA.event({
        category,
        action,
        value,
      });

      // 4. Mixpanel
      mixpanel.track(category, {
        action,
        value,
      });
    }
  }
};

export { trackAnalytics };

export function secondsToHms(d: any) {
  if (d === Infinity) {
    return d;
  }
  d = Number(d);
  const h: any = Math.floor(d / 3600);
  const m: any = Math.floor((d % 3600) / 60);
  const s = Math.floor((d % 3600) % 60);

  const hDisplay = h > 0 ? h + ':' : '';
  const mDisplay = m > -1 ? m + ':' : '';
  const sDisplay = s < 10 ? '0' + s : s;
  return hDisplay + mDisplay + sDisplay;
}

export const getProjectURL = (projectId: string) => {
  const url = window.location.href;
  const splitUrl = url.split('/');
  return `${splitUrl[0]}//${splitUrl[2]}/project/${projectId}`;
};

export function defaultTag(projectType: string) {
  return projectType === 'video'
    ? 'ScreenRecording'
    : projectType === 'whiteBoard'
    ? 'Whiteboard'
    : projectType.charAt(0).toUpperCase() + projectType.slice(1);
}

export function createThumbnailImg(data: any): any {
  return new Promise((resolve) => {
    let dataUrl = null;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = data;
    img.onload = async () => {
      if (img.height > 0 || img.width > 0) {
        const elem = document.createElement('canvas');
        let maxWidth = 460;
        let maxHeight = 270;
        if (img.height > img.width) {
          maxHeight = 270;
          maxWidth = (img.width / img.height) * maxHeight;

          elem.height = maxHeight;
          elem.width = maxWidth;
        } else {
          maxWidth = 460;
          maxHeight = (img.height / img.width) * maxWidth;

          elem.height = maxHeight;
          elem.width = maxWidth;
        }
        const ctx: any = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, maxWidth, maxHeight);
        dataUrl = elem.toDataURL();

        resolve(dataUrl);
      }
    };
  });
}

export function mobileCheck() {
  // let check = false;
  // const wondowObj: any = window;
  // ((a) => {
  //   if (
  //     /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
  //       a,
  //     ) ||
  //     /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
  //       a.substr(0, 4),
  //     )
  //   ) {
  //     check = true;
  //   }
  // })(navigator.userAgent || navigator.vendor || wondowObj.opera);
  // return check;
  return window.innerWidth < 850;
}

export const groupBy = (objectArray: any, property: any) => {
  return objectArray.reduce((acc: any, obj: any) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = 0;
    }
    // Add object to list for given key's value
    acc[key] = acc[key] + 1;
    return acc;
  }, {});
};

export const getImageFromVideo = (file: any, imageReady: any) => {
  const fileReader: any = new FileReader();
  fileReader.onload = () => {
    const blob = new Blob([fileReader.result], { type: file.type });
    const url = URL.createObjectURL(blob);
    const video: any = document.createElement('video');

    const snapImage = () => {
      const canvas: any = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      const image = canvas.toDataURL();
      const success = image.length > 100000;
      if (success) {
        const img = document.createElement('img');
        img.src = image;
        imageReady(img.src);
        // document.getElementsByTagName('div')[0].appendChild(img);
        URL.revokeObjectURL(url);
      }
      return success;
    };

    const timeupdate = () => {
      if (snapImage()) {
        video.removeEventListener('timeupdate', timeupdate);
        video.pause();
      }
    };
    video.addEventListener('loadeddata', () => {
      if (snapImage()) {
        video.removeEventListener('timeupdate', timeupdate);
      }
    });
    video.addEventListener('timeupdate', timeupdate);
    video.preload = 'metadata';
    video.src = url;
    video.muted = true;
    video.playsInline = true;

    video.currentTime = 10;
    video.play();
  };
  fileReader.readAsArrayBuffer(file);
};

export const checkout = (
  productId: number,
  planType: string,
  planTimeType: string,
  loginUserEmail: string,
  loginUserId: string,
) => {
  trackAnalytics('Payment', 'Payment initiated', `Payment initiated with ${planType} plan.`);
  const windowObj: any = window;
  const Paddle = windowObj.Paddle;
  if (loginUserEmail.length > 0) {
    Paddle.Checkout.open({
      product: productId,
      email: loginUserEmail,
      userId: loginUserId,
      planType,
      planTimeType,
      successCallback: (data: any, err: any) => {
        console.log('paddle response:', data, err);
        if (data && data.checkout && data.checkout.completed) {
          trackAnalytics(
            'Payment',
            'Payment successfully completed',
            `Payment successfully completed with ${planType} plan.`,
          );
          notification.success({
            message: 'Payment successfully completed, Plan update can take few minutes.',
          });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 3000);
        } else {
          trackAnalytics('Payment', 'Payment failed', `Payment failed with ${planType} plan.`);
          notification.error({
            message: `Payment failed, Error - ${JSON.stringify(err)}.`,
          });
        }
      },
    });
  } else {
    notification.error({
      message: `Email address is missing.`,
    });
  }
};

export const getOnBoardingSteps = (type: string) => {
  let steps: Array<{ target: string, content: string, disableBeacon?: boolean }> = [];
  switch (type) {
    case 'video':
    case 'webcam':
    case 'audio':
    case 'beta':
      steps = [
        {
          target: '.comment-icon',
          content: 'From here you can see the list of all the comments on the page',
          disableBeacon: true,
        },
        {
          target: '.notification-bell-icon',
          content: 'From here you can see the list of notifications',
        },
        {
          target: '.setting-icon',
          content: 'From here you can find the rest of the features',
        },
      ];
      break;
    case 'liveWebsite':
      steps = [
        {
          target: '.switch_buttons',
          content: 'Switch to browsing mode from here when you want to navigate to another page',
          disableBeacon: true,
        },
        {
          target: '.commenting',
          content: 'Select this option when you want to leave a comment at any part of the page',
        },
        {
          target: '.drawing-options',
          content: 'With these options, you can draw on the page',
        },
        {
          target: '.comment-icon',
          content: 'From here you can see the list of all the comments on the page',
        },
        {
          target: '.notification-bell-icon',
          content: 'From here you can see the list of notifications',
        },
        {
          target: '.setting-icon',
          content: 'From here you can find the rest of the features',
        },
      ];
      break;
    case 'whiteBoard':
    case 'image':
      steps = [
        {
          target: '.commenting',
          content: 'Select this option when you want to leave a comment at any part of the page',
          disableBeacon: true,
        },
        {
          target: '.drawing-options',
          content: 'With these options, you can draw on the page',
        },
        {
          target: '.comment-icon',
          content: 'From here you can see the list of all the comments on the page',
        },
        {
          target: '.notification-bell-icon',
          content: 'From here you can see the list of notifications',
        },
        {
          target: '.setting-icon',
          content: 'From here you can find the rest of the features',
        },
      ];
      break;
    default:
      steps = [];
  }
  return steps;
};

export const addThumnailURLInProject = async (videoUrl: string, projectId: string) => {
  const blob: any = await fetch(videoUrl).then((r) => r.blob());
  getImageFromVideo(blob, async (imgUrl: any) => {
    if (imgUrl) {
      const imgFirebaseUrl = await sendImageToStore(imgUrl);
      const thumbnailUrl = imgFirebaseUrl;
      const firestore = firebase.firestore();
      firestore
        .collection('projects')
        .doc(projectId)
        .update({ thumbnail_url: thumbnailUrl });
    }
  });
};

export const getVideoDurationFormat = (totalSecounds: number) => {
  const hours = Math.floor(totalSecounds / 3600);
  const minutes = Math.floor((totalSecounds / 60) % 60);
  const secounds = Math.floor(totalSecounds % 60);
  if (hours > 0) {
    return `${hours}:${minutes}:${secounds < 9 ? `0${secounds}` : secounds}`;
  } else {
    return `${minutes}:${secounds < 9 ? `0${secounds}` : secounds}`;
  }
};

export const validateEmail = (email: string) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const getDateToolTip = (createdAt: any) => {
  let dateFormat = 'MMM Do [at] h:mm:ss A z';
  if (moment(createdAt).years() !== new Date().getFullYear()) {
    dateFormat = 'MMM Do, YYYY [at] h:mm:ss A z';
  }
  const dateToolTip = moment(createdAt).format(dateFormat) || '';
  return dateToolTip;
};

export const checkImageAndGetProjectURL = (projectDetail: any) => {
  if (projectDetail.type === 'pdf') {
    return `/pdf/${projectDetail.id}`;
  } else if (projectDetail.type === 'audio') {
    return `/audio/${projectDetail.id}`;
  } else if (
    projectDetail.type === 'image' ||
    projectDetail.project_url.match(/\.(jpeg|jpg|gif|png)$/) != null ||
    projectDetail.project_url.includes('?alt=media')
  ) {
    return `/image/${projectDetail.id}?recalc=true`;
  } else if (projectDetail.type === 'whiteboard') {
    return `/whiteboard/${projectDetail.id}`;
  } else if (projectDetail.type === 'website') {
    return `/website/${projectDetail.id}`;
  } else if (projectDetail.type === 'text') {
    return `/text/${projectDetail.id}`;
  }
  return '/c/' + projectDetail.id;
};

export const getProjectImage = (projectDetail: any) => {
  if (projectDetail.project_base64_image && projectDetail.type === 'liveWebsite') {
    return (
      <img
        className='project-image'
        src={`data:image/png;base64, ${projectDetail.project_base64_image}`}
      />
    );
  } else if (projectDetail.project_base64_image && projectDetail.type === 'image') {
    return (
      <img
        className='project-image'
        src={
          projectDetail.project_base64_image.includes('data:image/')
            ? projectDetail.project_base64_image
            : `data:image/png;base64, ${projectDetail.project_base64_image}`
        }
      />
    );
  } else if (projectDetail.thumbnail_url && projectDetail.type === 'image') {
    return <img className='project-image' src={`${projectDetail.thumbnail_url}`} />;
  } else if (
    !(projectDetail.project_base64_image || projectDetail.thumbnail_url) &&
    !(projectDetail.type === 'video') &&
    !(projectDetail.type === 'webcam') &&
    !(projectDetail.type === 'whiteBoard')
  ) {
    return (
      <img
        className='project-placeholder-image'
        src={
          'data:image/png;base64, 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'
        }
      />
    );
  } else if (projectDetail.type === 'video' || projectDetail.type === 'webcam') {
    return (
      <img
        className={projectDetail.thumbnail_url ? 'project-image' : 'project-placeholder-image'}
        src={
          projectDetail.thumbnail_url ? projectDetail.thumbnail_url : Constant.videoThumbnailBase64
        }
      />
    );
  } else if (projectDetail.type === 'whiteBoard' || projectDetail.type === 'audio') {
    return <img className='project-placeholder-image' src={Constant.whiteBoardThumbnailBase64} />;
  }
};

export const getProjectImageURL = (projectDetail: any) => {
  const type = projectDetail && projectDetail.type && projectDetail.type.trim();
  if (projectDetail.project_base64_image && (type === 'liveWebsite' || type === 'website')) {
    return `data:image/png;base64,${projectDetail.project_base64_image}`;
  } else if (projectDetail.project_base64_image && type === 'image') {
    return projectDetail.project_base64_image.includes('data:image/')
      ? projectDetail.project_base64_image
      : `data:image/png;base64,${projectDetail.project_base64_image}`;
  } else if (projectDetail.thumbnail_url && type === 'image') {
    return `${projectDetail.thumbnail_url}`;
  } else if (
    type === 'video' ||
    type === 'webcam' ||
    type === 'videoRecord' ||
    type === 'videoUpload' ||
    type === 'videoByURL'
  ) {
    return projectDetail.thumbnail_url ? projectDetail.thumbnail_url : '';
  } else if (type === 'pdf') {
    return projectDetail.thumbnail_url ? projectDetail.thumbnail_url : '';
  }
};

export const hexToRGBA = (hex: string, opacity: number) => {
  hex = hex.replace('#', '');
  const r: number = parseInt(hex.substring(0, 2), 16);
  const g: number = parseInt(hex.substring(2, 4), 16);
  const b: number = parseInt(hex.substring(4, 6), 16);

  const result: string = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  return result;
};

export const copyURL = (url: string) => {
  const textArea = document.createElement('textarea');
  textArea.value = url;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('Copy');
  textArea.remove();
};

export const validateYouTubeUrl = (url: string) => {
  if (url !== undefined || url !== '') {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const checkChromeExtensionAndSendToken = async (uid: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  const isExtension = localStorage.getItem('extension');
  const isChromeExtension = urlParams.get('extension') || '';
  if (isExtension || isChromeExtension) {
    const fbInstance: any = firebase;
    const firebaseUserAuthToken = await fbInstance.auth().currentUser.getIdToken(true);
    generateCustomToken(firebaseUserAuthToken, uid).then((res: any) => {
      if (res && res.status && res.user) {
        window.localStorage.removeItem('extension');
        window.postMessage({ message: 'authToken', authToken: res.user }, '*');
      }
    });
  }
};

export const showFullFeature = () => {
  // @ts-ignore
  const params = new URL(document.location).searchParams;
  const fullFeature = params.get('full-feature') || false;
  return fullFeature;
};

export const getLastSelectedWorkflowAndMasterProjectId = () => {
  const selectedWorkflowId = window.localStorage.getItem('selectedWorkflowId');
  const selectedMasterProjectId = window.localStorage.getItem('selectedMasterProjectId');
  window.postMessage(
    {
      message: 'userSelectedWorkflowAndMasterProjectId',
      userSelectedWorkflowAndMasterProjectId: {
        selectedWorkflowId,
        selectedMasterProjectId,
      },
    },
    '*',
  );
  //workflowId, masterProjectId in projects document and
  // member_ids: [authorId]
  // const ticketNumber = await firestore
  //     .collection('masterProjects')
  //     .doc(project.masterProjectId)
  //     .get()
  //     .then((doc: any) => {
  //       const data = doc.data();
  //       return (data && data.ticketNumber && data.ticketNumber + 1) || 1;
  //     });

  //   projectDetail.ticketNumber = ticketNumber;

  // let workflow = selectedMasterProject.workflow || [];
  // let sequenceNumber = 1;
  // workflow = workflow.map((workflowItem: any) => {
  //   if (workflowItem.id === project.workflowId) {
  //     sequenceNumber = workflowItem.total + 1;
  //   }
  //   return workflowItem;
  // });
  // projectDetail.sequenceNumber = sequenceNumber;

  // update total in corresponding workflow and ticketNumber in masterProjects
  // update userQuota in users or organization

  // Doubt:
  /* 
  1. When we need to send these details to chrome extension
  I think, on login in chrome exension, creating canvas using website and keep persist data in chrome extension
  but it will not work 100%, if creating multiple canvas from chrom extension

  perfect solution, should be show a modal and ask to user to select.
  */
};

export const isWT = () => {
  const pageUrlParams = new URLSearchParams(window.location.search);
  const isWT = pageUrlParams.get('wt') || sessionStorage.getItem('isWT');

  pageUrlParams.get('wt') && sessionStorage.setItem('isWT', 'true');

  return !!isWT;
};
